import {
  Component,
  OnInit,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input
} from '@angular/core';
import {StsNotification} from '../../../../models/sts-notification.model';
import {StsSectionHeaderSideComponent} from '../sts-section-header-side/sts-section-header-side.component';

@Component({
  selector: 'app-sts-section-header',
  templateUrl: './sts-section-header.component.html',
  styleUrls: ['./sts-section-header.component.scss']
})
export class StsSectionHeaderComponent implements OnInit, AfterContentInit {

  @Input() key: string;
  @Input() errors: StsNotification[] = [];
  @Input() texts: StsNotification[] = [];
  @ContentChildren(StsSectionHeaderSideComponent) sideComponents: QueryList<StsSectionHeaderSideComponent>;

  public sides: StsSectionHeaderSideComponent[];

  constructor() { }

  ngOnInit() {
    if (!this.errors) {
      this.errors = [];
    }
  }

  ngAfterContentInit(): void {
    this.sides = this.sideComponents.toArray();
  }

  getClassCode(errors: StsNotification[]): string {

    // Temp hack: we need a better way to specify at the top level of
    // the notifications what type of message is this (success vs error).
    // Right now we need to assume that the level won't change within diff
    // errors.
    if (errors.length === 0) { return ''; }
    let message = errors[0];

    if (message.level === 1 || message.level === 4) {
      return 'message-error';
    }
    if ( message.level === 2) {
      return 'message-success';
    }
    if ( message.level === 3) {
      return 'message-warning';
    }
    if ( message.level === 0) {
      return 'message-info';
    }

    return '';
  }


}
